// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".div-top[data-v-56d54543],\n.div-search[data-v-56d54543] {\n  line-height: 30px;\n}\n.div-search[data-v-56d54543] {\n  margin-top: 10px;\n}\n.div-center[data-v-56d54543] {\n  margin-top: 10px;\n  height: calc(100% - 30px);\n}\n.title[data-v-56d54543] {\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 40px;\n}\n[data-v-56d54543] .el-drawer__header {\n  margin: 0;\n  padding: 20px;\n  font-weight: bold;\n  font-size: 20px;\n}", ""]);
// Exports
module.exports = exports;
